import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sources, findSourceByLandingURL } from "../data/sources";

export const SourceRedirect = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {

        const { pathname, search, hash } = location;

        // BenefitHub sent the wrong link (/programs instead of /). Redirect to home
        // preserving all UTM params. Check pathname first to avoid any loop.
        if (pathname === '/programs' && new URLSearchParams(search).get('utm_source') === 'benefithub' && new URLSearchParams(search).get('utm_medium') === 'email' && new URLSearchParams(search).get('utm_campaign') === 'solo_email_ad' && new URLSearchParams(search).get('utm_content') === 'switch_over') {
            navigate(`/${search}${hash || ''}`, { replace: true });
            return;
        }

        const pathParts = pathname.split('/');
        const sourceSegment = pathParts.length > 1 ? pathParts[1].toLowerCase() : '';

        // Check if the first segment is a known source
        const validSource = findSourceByLandingURL(sourceSegment);

        // If it's not a valid source, do nothing
        if (!validSource) return;

        // If it's the same source as the current utm_source, do nothing
        const currentUtmSource = new URLSearchParams(search).get('utm_source') ? new URLSearchParams(search).get('utm_source').toLowerCase() : '';
        if (currentUtmSource === validSource.utmSource) return;

        const utmSource = validSource.utmSource;

        // Valid source, redirect to same path without the source in the URL and add as query parameter
        const urlParams = new URLSearchParams(search);
        
        // Reconstruct the new path without the source
        const newPath = validSource.deletePathSegment ? "/" + pathParts.slice(2).filter(Boolean).join("/") : pathname;

        // Add source as a query parameter
        urlParams.set('utm_source', utmSource);
        const newSearch = urlParams.toString() ? `?${urlParams.toString()}` : '';

        // Perform the redirect
        navigate(`${newPath}${newSearch}${hash || ''}`, { replace: true });

    }, [location, navigate]);
}